import { MouseEvent } from 'react'

import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'

import styles from './reset-link.module.scss';


type Props = {
  children: string,
  onClick: (e: MouseEvent<HTMLButtonElement>) => void,
}

const ResetFilterLink = ({ children, onClick }: Props) => (
  <PlainButtonAsLink
    linkClassName={styles.resetLink}
    onClick={onClick}
  >
    {children}
  </PlainButtonAsLink>
)

export default ResetFilterLink
